const lang = document.documentElement.lang.substring(0, 2);

const labels = {
  gestureTouch: {
    de: 'Verschieben Sie den Kartenausschnitt mit zwei Fingern',
  },
  gestureScroll: {
    de: 'Verwenden Sie Strg + Scrollen zum Zoomen der Karte',
  },
  gestureScrollMac: {
    de: 'Verwenden Sie \u2318 zum Zoomen der Karte',
  },
  enterFullscreen: {
    de: 'Karte im Vollbildmodus ansehen',
  },
  exitFullscreen: {
    de: 'Vollbildmodus verlassen',
  },
  closeDetail: {
    de: 'Details schließen',
  },
  zoomIn: {
    de: 'Hereinzoomen',
  },
  zoomOut: {
    de: 'Herauszoomen',
  },
};

export { labels, lang };
